import React, { useState, useEffect, useContext, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Card,
  Alert,
  FormLabel,
} from "react-bootstrap";
import SimpleHeader from "components/Headers/SimpleHeader";
import { serverHost, createEndpoints } from "variables/serverdata";
import { ThemeContext } from "contexts/ThemeContext.jsx";
import { Input } from "reactstrap";

const dialplans = [
  { value: "transfer:*98 XML 10.0.190.48", label: "Check Voicemail" },
  { value: "transfer:*411 XML 10.0.190.48", label: "Company Directory" },
  { value: "hangup:", label: "Hangup" },
  { value: "transfer:*732 XML 10.0.190.48", label: "Record" },
];

const DestinationAdd = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [advanced, setAdvanced] = useState(false);
  const [error, setError] = useState("");
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";
  const currentSite = JSON.parse(localStorage.getItem("selectedSite"));
  const site_uuid = currentSite?.site_uuid || null;
  const domain_uuid = currentSite?.domain_uuid || null;
  const [conditions, setConditions] = useState([
    { field: "", type: "", value: "" },
  ]);
  const [actions, setActions] = useState([{ type: "", value: "" }]);
  // Data lists
  const [extensionList, setExtensionList] = useState([]);
  const [bridgeList, setBridgeList] = useState([]);
  const [voicemailList, setVoicemailList] = useState([]);
  const [flowsList, setFlowsList] = useState([]);
  const [ivrList, setIVRList] = useState([]);
  const [timeConditionsList, setTCList] = useState([]);
  const [destinationsList, setDestList] = useState([]);
  const [ringGroupList, setRingGroup] = useState([]);
  const [domainList, setDomainList] = useState([]);
  const [ringtonesList, setRingtonesList] = useState([]);
  const [tonesList, setTonesList] = useState([]);
  const [formData, setFormData] = useState({
    type: "inbound",
    prefix: "",
    did: "",
    caller_id_name: "",
    caller_id_number: "",
    caller_id_prefix: "",
    distinctive_ring: "",
    description: "",
    enabled: true,
    context: "",
    record: false,
    hold_music: "",
    order: 100,
    ringback: "",
    usage_voice: false,
    usage_text: false,
    usage_emergency: false,
  });
  const endpoints = useMemo(
    () =>
      createEndpoints({
        setExtensionList,
        setBridgeList,
        setVoicemailList,
        setFlowsList,
        setIVRList,
        setTCList,
        setDestList,
        setRingGroup,
        setDomainList,
        site_uuid
      }),
    []
  );

  useEffect(() => {
    const fetchDomain = async (e) => {
      try {
        const response = await fetch(
          `${serverHost}/fetch_domain_name/${site_uuid}`
        );
        if (!response.ok) throw new Error(`Failed to fetch domain context`);
        const data = await response.json();
        setFormData((prev) => ({ ...prev, context: data.result }));
      } catch (err) {
        setError(err.message);
      }
    };
    const fetchData = async () => {
      for (const key in endpoints) {
        const { url, map, setter } = endpoints[key];
        try {
          const res = await fetch(url);
          if (!res.ok) continue;

          const data = await res.json();
          const mapped = data.results.map(map);
          console.log(key, mapped);

          setter(mapped);
        } catch (err) {
          console.error(`Failed to fetch ${key}:`, err);
        }
      }
    };
    fetchData();
    fetchDomain();
  }, []);

  useEffect(() => {
    const fetchRingtones = async () => {
      try {
        const res = await fetch(
          `${serverHost}/get_rows?table=v_vars&pageSize=50&page=1&cfilter=var_category&vfilter=Ringtones`
        );
        if (res.ok) {
          const data = await res.json();
          console.log(data);
          const tones = data.results.map((r) => ({
            value: `\${${r.var_name}}`,
            name: r.var_name,
          }));
          console.log(tones);
          setRingtonesList(tones);
        }
      } catch (err) {
        console.error("Failed to fetch extensions:", err);
      }
    };
    const fetchTones = async () => {
      try {
        const res = await fetch(
          `${serverHost}/get_rows?table=v_vars&pageSize=50&page=1&cfilter=var_category&vfilter=Tones`
        );
        if (res.ok) {
          const data = await res.json();
          console.log(data);
          const tones = data.results.map((r) => ({
            value: `playback:tone_stream://${r.var_value}`,
            name: r.var_name,
          }));
          console.log(tones);
          setTonesList(tones);
        }
      } catch (err) {
        console.error("Failed to fetch extensions:", err);
      }
    };

    const fetchDestination = async () => {
      try {
        let res = await fetch(
          `${serverHost}/get_row?table=v_destinations&pk=destination_uuid&id=${encodeURIComponent(
            id
          )}`
        );
        if (!res.ok)
          throw new Error(
            res.status === 404 ? "Row not found" : "Failed to fetch row"
          );
        let data = await res.json();
        if (!data?.result) throw new Error("Row not found");
        let destination = data.result;
        console.log("Destination", destination)
        //deal with conditions list!

        if (destination.destination_conditions){
            const conds = destination.destination_conditions.map((v) => ({
            field: v.condition_field,
            value: v.condition_expression,
            type: `${v.condition_app}:${v.condition_data}`,
            }));
            console.log(conds);
            setConditions(conds);
        }
        if (destination.destination_actions) {
            const actions = destination.destination_actions.map((v) => ({
            type: v.destination_app,
            value: v.destination_data,
            }));
            console.log("actions", actions);
            setActions(actions);
        }
        setFormData({
          type: destination.destination_type,
          prefix: destination.destination_prefix,
          did: destination.destination_number,
          caller_id_name: destination.destination_caller_id_name,
          caller_id_number: destination.destination_caller_id_number,
          caller_id_prefix: destination.destination_cid_name_prefix,
          distinctive_ring: destination.destination_distinctive_ring,
          description: destination.destination_description,
          enabled: destination.destination_enabled,
          context: destination.destination_context,
          record: destination.destination_record,
          hold_music: destination.destination_hold_music,
          order: destination.destination_order,
          ringback: destination.destination_ringback,
          usage_voice: destination.destination_type_voice,
          usage_text: destination.destination_type_text,
          usage_emergency: destination.destination_type_emergency,
        });
      } catch (err) {

        console.error(err);
      }
    };

    fetchRingtones();
    fetchTones();

    if (id) {
      fetchDestination();
    }
  }, []);

  function parseAction(str) {
    const [type, ...rest] = str.split(":");
    return {
      type,
      value: rest.join(":"), // keep everything else as a single data string
    };
  }

  // Handle form field changes
  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  // --- Conditions handlers ---
  const addCondition = () =>
    setConditions((prev) => [...prev, { field: "", type: "", value: "" }]);
  const updateCondition = (index, key, value) => {
    setConditions((prev) =>
      prev.map((c, i) => (i === index ? { ...c, [key]: value } : c))
    );
  };
  const removeCondition = (index) =>
    setConditions((prev) => prev.filter((_, i) => i !== index));

  // --- Actions handlers ---
  const addAction = () => {
    setActions((prev) => [...prev, { type: "", value: "" }]);
  };

  const updateAction = (index, newAction) => {
    setActions((prev) => prev.map((a, i) => (i === index ? newAction : a)));
  };

  const removeAction = (index) => {
    setActions((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSave = async () => {
    console.log("Saving destination:", formData, conditions, actions);
    // Validate required fields
    const missingRequired = [];
    if (!formData.did) missingRequired.push("destination");
    const context =
      formData.context.trim() ||
      (formData.type === "inbound" ? "public" : window.location.hostname);
    if (missingRequired.length) {
      setError(`Missing required fields: ${missingRequired.join(", ")}`);
      return;
    }

    // Validate conditions

    const invalidConditions = conditions.filter((c) => !c.type || !c.value);
    if (invalidConditions.length > 0 && advanced) {
      setError("All conditions must have both type and value specified");
      return;
    }

    setError("");

    try {
      const site = JSON.parse(localStorage.getItem("selectedSite"));

      const payload = {
        data: {
          ...formData,
          advanced: advanced,
          conditions: conditions,
          actions: actions,
          dialplan_context: context,
          dialplan_type: "inbound",
        },
        client_uuid: site.client_uuid,
        site_name: site.company_name,
        insert_uuid: JSON.parse(localStorage.getItem("user")).user_uuid,
      };
      if (id) payload.site_uuid = site.site_uuid
        const res = await fetch(
        `${serverHost}/upsert_destination/${id ? id : site.site_uuid}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) {
        let fail = "";
        if (res.status === 403) fail = "; Limit reached";
        throw new Error("Failed to insert record" + fail);
      }

      navigate("/admin/hucs/destinations");
    } catch (err) {
      console.log(err);
      setError(err.message);
    }
  };
  const labelStyle = {
    fontWeight: "bolder",
    color: isDark ? "#e2e8f0" : "#1e3a5f",
    marginBottom: "0.5rem",
  };
  const handleBack = () => navigate("/admin/hucs/destinations");

  return (
    <>
      <SimpleHeader name={ `${id ? "Edit" : "Add "} Destination `} parentName="HUCS" />

      <Container className="mt--6">
        <Card className="shadow-sm" style={{ marginTop: "-3rem" }}>
          <Card.Header
            style={{
              backgroundColor: isDark ? "#1f2937" : "#e9ecef",
              color: isDark ? "#e2e8f0" : "#1e3a5f",
              borderBottom: "none",
              padding: "1rem 1.5rem",
            }}
          >
            <h4 className="mb-0">{`${id ? "EDIT" : "ADD"}`} DESTINATION {formData.type}</h4>
          </Card.Header>

          <Card.Body className="p-4">
            {error && <Alert variant="danger">{error}</Alert>}

            <Form className="edit-form">
              {/* ===========================
                    INFO SECTION
                ============================ */}
              <div className="mb-4">
                <Row className="d-flex justify-content-between align-items-center">
                  <h5 style={{ fontSize: "1.5rem", fontWeight: 700 }}>Info</h5>
                  <Button
                    size="sm"
                    onClick={() => setAdvanced((prev) => !prev)}
                  >
                    {advanced ? "Basic" : "Advanced"}
                  </Button>
                </Row>

                <Row>
                  {/* ---- Shared: Type ---- */}
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label style={labelStyle}>
                        Type <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Input
                        type="select"
                        name="type"
                        value={formData.type}
                        onChange={handleChange}
                      >
                        <option value="">Select...</option>
                        <option value="inbound">Inbound</option>
                        <option value="outbound">Outbound</option>
                      </Input>
                    </Form.Group>
                  </Col>

                  {/* ---- Shared: Country Code ---- */}
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Country Code
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="prefix"
                        value={formData.prefix}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  {/* ---- Shared: DID ---- */}
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label style={labelStyle}>
                        DID <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="did"
                        value={formData.did}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  {/* ---- Shared: Ringback ---- */}
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Ringback</Form.Label>
                      <Input
                        type="select"
                        name="ringback"
                        value={formData.ringback || ""}
                        onChange={handleChange}
                        placeholder="Defines what caller hears while destination is being called"
                      >
                        <option value="">Select...</option>
                        <optgroup label="Music on Hold"></optgroup>
                        <optgroup label="Ringtones">
                          {ringtonesList.map((rt) => (
                            <option key={rt.name} value={rt.value}>
                              {rt.name}
                            </option>
                          ))}
                          <option key="silence" value="silence">
                            Silence
                          </option>
                        </optgroup>
                        <optgroup label="Tones">
                          {tonesList.map((tone) => (
                            <option key={tone.name} value={tone.value}>
                              {tone.name}
                            </option>
                          ))}
                        </optgroup>
                      </Input>
                    </Form.Group>
                  </Col>

                  {/* ---- Shared: Usage (checkboxes) ---- */}
                  <Col md={8}>
                    <Form.Group className="mb-3">
                      <Form.Label>Usage</Form.Label>
                      <div>
                        <Form.Check
                          inline
                          label="Voice"
                          type="checkbox"
                          id="usage_voice"
                          name="usage_voice"
                          checked={!!formData.usage_voice}
                          onChange={handleChange}
                        />
                        <Form.Check
                          inline
                          label="Text"
                          type="checkbox"
                          id="usage_text"
                          name="usage_text"
                          checked={!!formData.usage_text}
                          onChange={handleChange}
                        />
                        <Form.Check
                          inline
                          label="Emergency"
                          type="checkbox"
                          id="usage_emergency"
                          name="usage_emergency"
                          checked={!!formData.usage_emergency}
                          onChange={handleChange}
                        />
                      </div>
                    </Form.Group>
                  </Col>

                  {/* ===========================
                        INBOUND ONLY FIELDS
                    ============================ */}
                  {formData.type === "inbound" && (
                    <>
                      {/* ---- Inbound: Caller ID Name ---- */}
                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label>Caller ID Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="caller_id_name"
                            value={formData.caller_id_name}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>

                      {/* ---- Inbound: Caller ID Number ---- */}
                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label>Caller ID Number</Form.Label>
                          <Form.Control
                            type="text"
                            name="caller_id_number"
                            value={formData.caller_id_number}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>

                      {/* ---- Conditions ---- */}
                      <Col md={12}>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <Form.Label style={{ fontWeight: 600 }}>
                            Conditions
                          </Form.Label>
                          <Button
                            variant="success"
                            size="sm"
                            onClick={addCondition}
                          >
                            + Add Condition
                          </Button>
                        </div>

                        {conditions.map((c, i) => (
                          <Card
                            key={i}
                            className="mb-3"
                            style={{ backgroundColor: "#f8f9fa" }}
                          >
                            <Card.Body>
                              <Row>
                                <Col md={4}>
                                  <Form.Group>
                                    <Form.Label>Field</Form.Label>
                                    <Input
                                      type="select"
                                      value={c.field} // ← each condition tracks its own field
                                      onChange={(e) =>
                                        updateCondition(
                                          i,
                                          "field",
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="">Select field...</option>
                                      <option value="caller_id_number">
                                        Caller ID Number
                                      </option>
                                      <option value="caller_id_number_prefix">
                                        Caller ID Number (Prefix)
                                      </option>
                                    </Input>
                                    <Form.Label>Condition</Form.Label>
                                    <Input
                                      type="select"
                                      value={c.type}
                                      onChange={(e) => {
                                        updateCondition(i, e.target.value);
                                      }}
                                    >
                                      <option value="">Select...</option>
                                      <optgroup label="Bridges">
                                        {bridgeList.map((br) => (
                                          <option
                                            key={br.bridge_uuid}
                                            value={`bridge:${br.destination}`}
                                          >
                                            {br.name}
                                          </option>
                                        ))}
                                      </optgroup>
                                      <optgroup label="Call Flows">
                                        {flowsList.map((cf) => (
                                          <option
                                            key={cf.name}
                                            value={`transfer:${cf.value}`}
                                          >
                                            {cf.name}
                                          </option>
                                        ))}
                                      </optgroup>
                                      <optgroup label="Destinations">
                                        {destinationsList.map((d) => (
                                          <option
                                            key={d.value}
                                            value={`transfer:${d.value}`}
                                          >
                                            {d.name}
                                          </option>
                                        ))}
                                      </optgroup>
                                      <optgroup label="Extensions">
                                        {extensionList.map((ext) => (
                                          <option
                                            key={ext.extension_uuid}
                                            value={`transfer:${ext.name} XML ${ext.accountcode}`}
                                          >
                                            {ext.name}
                                          </option>
                                        ))}
                                      </optgroup>
                                      <optgroup label="IVR Menus">
                                        {ivrList.map((ivr) => (
                                          <option
                                            key={ivr.name}
                                            value={`transfer:${ivr.transfer}`}
                                          >
                                            {ivr.name}
                                          </option>
                                        ))}
                                      </optgroup>
                                      <optgroup label="Ring Groups">
                                        {ringGroupList.map((rg) => (
                                          <option
                                            key={rg.value}
                                            value={`transfer:${rg.value}`}
                                          >
                                            {rg.name}
                                          </option>
                                        ))}
                                      </optgroup>
                                      <optgroup label="Time Conditions">
                                        {timeConditionsList.map((tc) => (
                                          <option
                                            key={tc.name}
                                            value={`transfer:${tc.value}`}
                                          >
                                            {tc.name}
                                          </option>
                                        ))}
                                      </optgroup>
                                      <optgroup label="Voicemails">
                                        {voicemailList.map((vm) => (
                                          <option
                                            key={vm.voicemail_uuid}
                                            value={`transfer:${vm.value}`}
                                          >
                                            {vm.voicemail_id}
                                          </option>
                                        ))}
                                      </optgroup>
                                      <optgroup label="Tones">
                                        {tonesList.map((tone) => (
                                          <option
                                            key={tone.name}
                                            value={tone.value}
                                          >
                                            {tone.name}
                                          </option>
                                        ))}
                                      </optgroup>
                                      <optgroup label="Dialplans">
                                        {dialplans.map((dp) => (
                                          <option
                                            key={dp.value}
                                            value={dp.value}
                                          >
                                            {dp.label}
                                          </option>
                                        ))}
                                      </optgroup>
                                    </Input>
                                  </Form.Group>
                                </Col>

                                <Col md={6}>
                                  <Form.Group>
                                    <Form.Label>Value</Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={c.value}
                                      onChange={(e) =>
                                        updateCondition(
                                          i,
                                          "value",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </Form.Group>
                                </Col>

                                <Col md={2} className="d-flex align-items-end">
                                  {conditions.length > 1 && (
                                    <Button
                                      variant="danger"
                                      size="sm"
                                      onClick={() => removeCondition(i)}
                                    >
                                      ✕
                                    </Button>
                                  )}
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        ))}
                      </Col>

                      {/* ---- Actions ---- */}
                      <Col md={12}>
                        <Form.Label style={labelStyle}>
                          Actions <span style={{ color: "red" }}>*</span>
                        </Form.Label>

                        {actions.map((a, i) => (
                          <Row key={i} className="mb-2 align-items-center">
                            <Col md={10}>
                              <Input
                                type="select"
                                value={`${a.type}:${a.value}`}
                                onChange={(e) => {
                                  const parsed = parseAction(e.target.value);
                                  updateAction(i, parsed);
                                }}
                              >
                                <option value="">Select...</option>
                                <optgroup label="Bridges">
                                  {bridgeList.map((br) => (
                                    <option
                                      key={br.bridge_uuid}
                                      value={`bridge:${br.destination}`}
                                    >
                                      {br.name}
                                    </option>
                                  ))}
                                </optgroup>
                                <optgroup label="Call Flows">
                                  {flowsList.map((cf) => (
                                    <option
                                      key={cf.name}
                                      value={`transfer:${cf.value}`}
                                    >
                                      {cf.name}
                                    </option>
                                  ))}
                                </optgroup>
                                <optgroup label="Destinations">
                                  {destinationsList.map((d) => (
                                    <option
                                      key={d.value}
                                      value={`transfer:${d.value}`}
                                    >
                                      {d.name}
                                    </option>
                                  ))}
                                </optgroup>
                                <optgroup label="Extensions">
                                  {extensionList.map((ext) => (
                                    <option
                                      key={ext.extension_uuid}
                                      value={`transfer:${ext.name} XML ${ext.accountcode}`}
                                    >
                                      {ext.name}
                                    </option>
                                  ))}
                                </optgroup>
                                <optgroup label="IVR Menus">
                                  {ivrList.map((ivr) => (
                                    <option
                                      key={ivr.name}
                                      value={`transfer:${ivr.transfer}`}
                                    >
                                      {ivr.name}
                                    </option>
                                  ))}
                                </optgroup>
                                <optgroup label="Ring Groups">
                                  {ringGroupList.map((rg) => (
                                    <option
                                      key={rg.value}
                                      value={`transfer:${rg.value}`}
                                    >
                                      {rg.name}
                                    </option>
                                  ))}
                                </optgroup>
                                <optgroup label="Time Conditions">
                                  {timeConditionsList.map((tc) => (
                                    <option
                                      key={tc.name}
                                      value={`transfer:${tc.value}`}
                                    >
                                      {tc.name}
                                    </option>
                                  ))}
                                </optgroup>
                                <optgroup label="Voicemails">
                                  {voicemailList.map((vm) => (
                                    <option
                                      key={vm.voicemail_uuid}
                                      value={`transfer:${vm.value}`}
                                    >
                                      {vm.voicemail_id}
                                    </option>
                                  ))}
                                </optgroup>
                                <optgroup label="Tones">
                                  {tonesList.map((tone) => (
                                    <option key={tone.name} value={tone.value}>
                                      {tone.name}
                                    </option>
                                  ))}
                                </optgroup>
                                <optgroup label="Dialplans">
                                  {dialplans.map((dp) => (
                                    <option key={dp.value} value={dp.value}>
                                      {dp.label}
                                    </option>
                                  ))}
                                </optgroup>
                              </Input>
                            </Col>

                            <Col md={2}>
                              {actions.length > 1 && (
                                <Button
                                  variant="danger"
                                  size="sm"
                                  onClick={() => removeAction(i)}
                                >
                                  ✕
                                </Button>
                              )}
                            </Col>
                          </Row>
                        ))}

                        <Button variant="success" size="sm" onClick={addAction}>
                          + Add Action
                        </Button>
                      </Col>

                      {/* ---- Inbound: Caller ID Prefix ---- */}
                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label>Caller ID Prefix</Form.Label>
                          <Form.Control
                            type="text"
                            nome="caller_id_prefix"
                            value={formData.caller_id_prefix}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>

                      {/* ---- Inbound: Distinctive Ring ---- */}
                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label>Distinctive Ring</Form.Label>
                          <Form.Control
                            type="text"
                            name="distinctive_ring"
                            value={formData.distinctive_ring}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>

                      {/* ---- Inbound: Hold Music ---- */}
                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label>Hold Music</Form.Label>
                          <Input
                            type="select"
                            value={formData.hold_music}
                            onChange={(e) =>
                              handleChange("hold_music", e.target.value)
                            }
                          >
                            <option value="">Select...</option>
                            <optgroup label="Music on Hold">
                              <option
                                id="default"
                                value={"local_stream://default"}
                              >
                                default
                              </option>
                            </optgroup>
                            <optgroup label="Others">
                              <option id="None" value="silence">
                                None
                              </option>
                            </optgroup>
                          </Input>
                        </Form.Group>
                      </Col>
                    </>
                  )}

                  {/* ===========================
                        SHARED OTHER FIELDS
                    ============================ */}
                  {/* ---- Shared: Description ---- */}
                  <Col md={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        value={formData.description}
                        name="description"
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  {/* ---- Shared: Enabled ---- */}
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.75rem",
                          marginBottom: "1.5rem",
                        }}
                      >
                        <span style={{ color: isDark ? "#e2e8f0" : "#495057" }}>
                          Enabled
                        </span>

                        <label className="custom-toggle mb-0">
                          <input
                            type="checkbox"
                            id="enabled"
                            name="enabled"
                            checked={formData.enabled}
                            onChange={handleChange}
                          />
                          <span
                            className="custom-toggle-slider rounded-circle"
                            data-label-off="Off"
                            data-label-on="On"
                          />
                        </label>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </div>

              {/* ===========================
                    ADVANCED SETTINGS
                ============================ */}
              {advanced && (
                <div className="mb-4">
                  <h5 style={{ fontSize: "1.5rem", fontWeight: 700 }}>
                    Advanced Settings
                  </h5>

                  <Row>
                    {/* Shared: Context */}
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Context</Form.Label>
                        <Form.Control
                          type="text"
                          name="context"
                          value={formData.context}
                          onChange={handleChange}
                          disabled
                        />
                      </Form.Group>
                    </Col>

                    {/* Shared: Record */}
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Record</Form.Label>
                        <Input
                          type="select"
                          value={formData.record}
                          onChange={(e) =>
                            handleChange("record", e.target.value === "true")
                          }
                        >
                          <option value="false">False</option>
                          <option value="true">True</option>
                        </Input>
                      </Form.Group>
                    </Col>

                    {/* Shared: Order */}
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Order</Form.Label>
                        <Form.Control
                          type="number"
                          name="order"
                          value={formData.order}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              )}

              {/* ===========================
                    ACTION BUTTONS
                ============================ */}
              <div className="mt-4 d-flex justify-content-between">
                <Button
                  variant="danger"
                  onClick={handleBack}
                >
                  Cancel
                </Button>

                <Button
                  variant="success"
                  onClick={handleSave}
                  disabled={!formData.did}
                >
                  Save
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default DestinationAdd;
